<template>
  <div
    class="flex-fill flex flex-row bgc-white"
    style="padding: 0; height: 100%; min-width: 1200px;"
  >
    <aside-menu
      :active-index="activeIndex"
      :guide-visible="guideVisible"
      :feedback-url="feedbackUrl"
      @add="handleAdd"
      @click-guide="handleGuideClick"
    />
    <questionnaire-table-home
      :current="current"
      :total="total"
      :size="size"
      :rows="rows"
      @publish="handlePublish"
      @unpublish="handleUnpublish"
      @share="handleShare"
      @edit="handleEdit"
      @count="handleCount"
      @delete="handleDelete"
      @search="handleSearch"
    >
      <template slot="empty">
        <span v-if="isLogin">暂无数据</span>
        <a v-else :href="loginUrl">
          <el-button
            type="primary"
            style="line-height: 18px; font-size: 18px; padding: 10px 60px;"
            >去登录</el-button
          >
        </a>
      </template>
      <template #title="{ row }">
        <el-button
          type="text"
          @click="handleAnswer(row)"
          class="title"
          style="padding: 0;"
          ><icon-title :type="row.type" :title="row.title"
        /></el-button>
      </template>
    </questionnaire-table-home>
    <share-qrcode-dialog
      :visible="shareVisible"
      :share-url="shareUrl"
      :qr-code="qrCode"
      :show-q-r-code="qrcodeVisible"
      :title="shareTitle"
      :unique-id="shareUniqueId"
      @on-close="shareVisible = false"
    />
    <div class="guide-marker" :style="guideMarkerStyle"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapState, mapActions } from "vuex";
import store from "@/store";
import QuestionnaireTableHome from "@/components/questionnaire/TableHome";
import * as LinkHelper from "@/utils/LinkHelper";
import ErrorHandler from "@/utils/ErrorHandler";
import { Message, Button } from "element-ui";
import AsideMenu from "@/components/questionnaire/AsideMenu";
import IconTitle from "@/components/collector/IconTitle";
import ShareQrcodeDialog from "@/components/share/ShareQrcodeDialog";
import {
  obtainToAnswerFormUrl,
  obtainToAnswerMobileUrl,
  obtainToAnswerTableUrl,
} from "@/utils/LinkHelper";
export default {
  name: "home",
  components: {
    ShareQrcodeDialog,
    IconTitle,
    AsideMenu,
    QuestionnaireTableHome,
    [Button.name]: Button,
  },
  computed: {
    ...mapGetters({
      rows: "questionnaire/stateRows",
      isLogin: "user/isLogin",
    }),
    ...mapState({
      current: (state) => state.questionnaire.page.current,
      total: (state) => state.questionnaire.page.total,
      size: (state) => state.questionnaire.page.size,
      allGuideVisible: (state) => state.user.guide.visible,
    }),
    loginUrl: {
      get() {
        return LinkHelper.obtainLoginUrl();
      },
    },
    guideMarkerStyle() {
      const { guideVisible } = this;
      const show = guideVisible[0] || guideVisible[1];
      return {
        display: show ? "block" : "none",
      };
    },
  },
  data() {
    return {
      activeIndex: "1",
      guideVisible: [this.allGuideVisible, this.allGuideVisible],
      keyword: null,
      feedbackUrl: LinkHelper.obtainFeedbackUrl(),
      shareVisible: false,
      qrcodeVisible: false,
      shareUrl: "",
      qrCode: "",
      shareTitle: "",
      shareUniqueId: "",
    };
  },
  watch: {
    allGuideVisible: "updateVisible",
    "navigator.userAgent": () => console.log("我改变了"),
  },
  methods: {
    ...mapActions({
      search: "questionnaire/search",
      publish: "questionnaire/publish",
      publishTable: "table/publish",
      stopTable: "table/stop",
      moveTableToTrash: "table/moveToTrash",
      unpublish: "questionnaire/unpublish",
      delete: "questionnaire/delete",
      checkLogin: "user/checkLogin",
      recordGuide: "user/recordGuide",
    }),
    handlePublish(row) {
      const { uniqueId, type } = row;
      if (type === 1) {
        this.publish({ uniqueId }).then(({ success, data }) => {
          if (success) {
            this.$router.push({
              name: "questionnaireShare",
              params: { uniqueId, published: true },
              query: { type: 1 },
            });
          } else if (data) {
            Message.warning(data.msg);
          }
        });
      } else if (type === 2) {
        this.publishTable({ uniqueId }).then((success) => {
          if (success) {
            this.$router.push({
              name: "questionnaireShare",
              params: { uniqueId, published: true },
              query: { type: 2 },
            });
          }
        });
      } else {
        Message.warning("暂未支持的类型");
      }
    },
    async handleUnpublish(row) {
      const success = await this.stopCollector(row);
      if (success) {
        this.handleSizeChange(this.size);
      }
    },
    async stopCollector(row) {
      const { uniqueId, type } = row;
      if (type === 1) {
        return await this.unpublish({ uniqueId });
      } else if (type === 2) {
        return await this.stopTable(uniqueId);
      }
      Message.warning("暂未支持的类型");
      return false;
    },
    handleSizeChange(val) {
      const payload = {
        title: this.keyword,
        pageIndex: this.current,
        pageSize: val,
      };
      this.handleSearch(payload);
    },
    handleCurrentChange(val) {
      const payload = {
        title: this.keyword,
        pageIndex: val,
        pageSize: this.size,
      };
      this.handleSearch(payload);
    },
    handleShare(row) {
      const { uniqueId, type, title } = row;
      this.shareTitle = title;
      this.shareUniqueId = uniqueId;
      if (type === 1) {
        this.qrCode = obtainToAnswerMobileUrl(this.$router.mode, uniqueId);
        this.shareVisible = true;
        this.qrcodeVisible = true;
        obtainToAnswerFormUrl(this.$router.mode, uniqueId).then(
          (it) => (this.shareUrl = it)
        );
      } else if (type === 2) {
        obtainToAnswerTableUrl(this.$router.mode, uniqueId).then(
          (it) => (this.shareUrl = it)
        );
        this.shareVisible = true;
        this.qrcodeVisible = false;
      } else {
        Message.warning("暂未支持的类型");
      }
      // this.$router.push({
      //   name: "questionnaireShare",
      //   params: { uniqueId, published: false },
      // });
    },
    handleAnswer(row) {
      // console.log("我要答题", row);
      const { uniqueId, published, type } = row;
      if (!published) {
        Message.warning("收集表未发布");
        return;
      }
      if (type === 1) {
        this.$router.push({
          name: "answerQuestionnaire",
          params: { uniqueId },
        });
      } else if (type === 2) {
        this.$router.push({
          name: "answerTable",
          params: { uniqueId },
        });
      } else {
        Message.warning("未支持的类型");
      }
    },
    handleAdd() {
      this.$router.push({
        name: "template",
      });
    },
    handleEdit(row) {
      const { uniqueId, type } = row;
      if (type !== 1) {
        Message.warning("暂未支持的类型");
        return;
      }
      this.$router.push({
        name: "editQuestionnaire",
        params: { uniqueId },
      });
    },
    handleCount(row) {
      const { uniqueId, type } = row;
      if (type !== 1) {
        Message.warning("暂未支持的类型");
        return;
      }
      this.$router.push({
        name: "questionnaireStatistic",
        params: { uniqueId },
      });
    },
    handleDelete(row) {
      const { uniqueId, type } = row;
      if (type === 1) {
        this.delete({ uniqueId }).then((success) => {
          if (success) {
            this.handleSearch({});
          }
        });
      } else if (type === 2) {
        this.moveTableToTrash(uniqueId).then((success) => {
          if (success) {
            this.handleSearch({});
          }
        });
      } else {
        Message.warning("暂未支持的类型");
      }
    },
    handleSearch(payload) {
      const { published } = this.$route.query;
      if (published === "false") {
        this.search({ ...payload, published: false });
      } else {
        this.search(payload);
      }
    },
    updateVisible() {
      const visibleList = [...this.guideVisible];
      visibleList.fill(this.allGuideVisible);
      this.guideVisible = visibleList;
    },
    handleGuideClick(index) {
      if (this.guideVisible[index] === false) {
        return;
      }
      const visibleList = [...this.guideVisible];
      visibleList[index] = false;
      this.guideVisible = visibleList;
      if (this.guideVisible.every((it) => !it)) {
        this.recordGuide();
      }
    },
  },
  created() {
    this.updateVisible();
    const { published } = this.$route.query;
    if (published === "false") {
      this.activeIndex = "2";
    }
  },
  async beforeRouteUpdate(to, from, next) {
    try {
      const payload = {};
      const { published } = to.query;
      if (`${published}` === "false") {
        payload.published = false;
      }
      this.search(payload);
      next();
    } catch (e) {
      ErrorHandler(next)(e);
    }
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const { dispatch } = store;
      await dispatch("user/checkLogin", { followRedirect: false });
      await dispatch("user/checkGuide");
      // console.log(to);
      const { published } = to.query;
      if (`${published}` === "false") {
        await dispatch("questionnaire/search", { published: false });
      } else {
        await dispatch("questionnaire/search", {});
      }
      next();
    } catch (e) {
      ErrorHandler(next)(e);
    }
  },
};
</script>
<style>
.guide-marker {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.2);
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}
</style>
